import { render, staticRenderFns } from "./CFTaskDetails.vue?vue&type=template&id=30f99f42&"
import script from "./CFTaskDetails.vue?vue&type=script&lang=ts&"
export * from "./CFTaskDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports